/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPagingControl = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M6.8 8.6 4.25 12l2.55 3.4-1.6 1.2-3-4-.45-.6.45-.6 3-4zm15 2.8-3-4-1.6 1.2 2.55 3.4-2.55 3.4 1.6 1.2 3-4 .45-.6zM10 14.055V15h4.257v-1.143h-2.43l.909-.999c.372-.414.666-.768.882-1.062.222-.3.381-.57.477-.81s.144-.48.144-.72c0-.588-.192-1.041-.576-1.359s-.924-.477-1.62-.477c-.312 0-.633.042-.963.126a4.101 4.101 0 0 0-.909.333v1.206c.618-.33 1.17-.495 1.656-.495.69 0 1.035.273 1.035.819 0 .132-.036.276-.108.432-.072.15-.198.336-.378.558-.174.216-.42.498-.738.846z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgPagingControl as PagingControl };
